// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';

import { getInitialTimeFrame, getTimeStepForTimeFrame } from '@/helpers/reporting.helpers';
import ReportingAdvancedFilterResumePanel from '@/modules/reporting/ReportingAdvancedFilterResumePanel/ReportingAdvancedFilterResumePanel';
import { getAdvancedFiltersEnabled, getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getCampaigns } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { GeneralFiltersStyle } from '@/ts-modules/reporting/GeneralFilters/generalFilters.styled';

type Props = {
  initialCurrency: string;
};

function GeneralFilters({ initialCurrency }: Props) {
  const advancedFiltersEnabled = useSelector(getAdvancedFiltersEnabled);
  const reportingCampaigns = useSelector(getSelectedCampaigns);
  const selectedReportingCampaignsIds = useSelector(getCampaigns);
  const initialDates = getInitialTimeFrame(
    reportingCampaigns.filter(({ id }: { id: string }) => selectedReportingCampaignsIds.includes(id))
  );
  const initialTimeStep = getTimeStepForTimeFrame(initialDates);

  if (!reportingCampaigns.length) {
    return null;
  }

  return (
    <GeneralFiltersStyle>
      <ReportingAdvancedFilterResumePanel
        enabled={advancedFiltersEnabled}
        initialSettings={{
          chartTimeStep: initialTimeStep,
          currency: initialCurrency,
          timeFrame: initialDates,
          timeStep: initialTimeStep,
          timeZone: reportingCampaigns[0].timezone
        }}
        section="general"
      />
    </GeneralFiltersStyle>
  );
}

export default GeneralFilters;
